import { Button } from "./Button";
import { cn } from "@/lib/cn";

/**
 * Pill filter with an optional count.
 *
 * Built on the Sebas Button (not HakiUI's directly) so the contrast-corrected
 * variant colours apply here too — an active chip is a primary surface.
 * `aria-pressed` conveys the selected state, since the difference is only colour.
 */
export function Chip({
  active = false,
  count,
  children,
  className,
  ...props
}: Omit<React.ComponentProps<typeof Button>, "variant" | "size" | "radius"> & {
  active?: boolean;
  count?: number;
}) {
  return (
    <Button
      variant={active ? "primary" : "outline"}
      size="sm"
      radius="full"
      aria-pressed={active}
      className={cn("shrink-0 gap-2", className)}
      {...props}
    >
      {children}
      {count !== undefined ? (
        <span
          className={cn(
            "grid h-5 min-w-5 place-items-center rounded-full px-1 text-[0.6875rem] font-semibold",
            active ? "bg-black/12 text-current" : "bg-sunken text-ink-muted",
          )}
        >
          {count}
        </span>
      ) : null}
    </Button>
  );
}
